import api from '../lib/api'

export const getManagerUsers = (orgId) =>
  api.get(`/manager/users/${orgId}`).then((r) => r.data ?? [])

export const getBranchUsers = (branchId, skip = 0, limit = 50, includeDeleted = true) =>
  api
    .get(`/manager/branches/${branchId}/users`, {
      params: {
        include_deleted: includeDeleted,
        skip,
        limit,
      },
    })
    .then((r) => {
      const data = r.data ?? {}
      const pagination = data.pagination ?? {}
      return {
        pagination: {
          total: Number.isFinite(Number(pagination.total)) ? Number(pagination.total) : 0,
          skip: Number.isFinite(Number(pagination.skip)) ? Number(pagination.skip) : skip,
          limit: Number.isFinite(Number(pagination.limit)) ? Number(pagination.limit) : limit,
        },
        items: Array.isArray(data.items) ? data.items : [],
      }
    })

export const inviteUser = (orgId, payload) =>
  api.post(`/manager/users/${orgId}/invite`, payload).then((r) => r.data)

export const getManagerInvitations = (branchId, skip = 0, limit = 50) =>
  api
    .get('/manager/invitations', {
      params: {
        branch_id: branchId,
        skip,
        limit,
      },
    })
    .then((r) => {
      const data = r.data ?? {}
      return {
        count: Number.isFinite(Number(data.count)) ? Number(data.count) : 0,
        items: Array.isArray(data.items) ? data.items : [],
        skip: Number.isFinite(Number(data.skip)) ? Number(data.skip) : skip,
        limit: Number.isFinite(Number(data.limit)) ? Number(data.limit) : limit,
      }
    })

export const getInviteInfo = (inviteToken) =>
  api
    .get('/manager/auth/invite-info', {
      params: { invite_token: inviteToken },
      timeout: 15000,
    })
    .then((r) => r.data)

export const acceptInvite = (inviteToken) =>
  api
    .post(
      '/manager/auth/accept-invite',
      {
        invite_token: inviteToken,
      },
      { timeout: 15000 }
    )
    .then((r) => r.data)

export const patchUserRole = (tenantId, userId, branchId, role) =>
  api
    .patch(`/manager/users/${tenantId}/${userId}/role`, {
      branch_id: branchId,
      role,
    })
    .then((r) => r.data)

export const patchUserStatus = (tenantId, userId, status) =>
  api.patch(`/manager/users/${tenantId}/${userId}/status`, { status }).then(r => r.data)

export const deleteUserBranchAssignment = (orgId, userId, branchId) =>
  api.delete(`/manager/users/${orgId}/${userId}/assignments/${branchId}`).then((r) => r.data)
